module.exports = __webpack_public_path__ + "static/media/kyc-sample-ktp.358634a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kyc-sample-ktp.png
// module id = 650
// module chunks = 8